import React from "react";

const SelectTag = ({ item }) => {
  const { label, name, defaultValue, required, options } = item;

  return (
    <div className=" flex flex-row gap-4 items-centers w-full fitHeight  ">
      <div className="col-span-2 w-full ">
        <div className={"flex gap-1 items-end w-full"}>
          <div className="w-full">
            <label className="label">
              <span className="text-md font-semibold">{label}</span>
            </label>
            <select
              name={name}
              selected
              className="select select-bordered bg-[#3D4451] text-white uppercase w-full"
              required={required}
            >
              {/* {defaultValue && (
                <option disabled selected>
                  {defaultValue}
                </option>
              )} */}
              {options.map((item, index) => (
                <option selected={item  === defaultValue} key={index} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectTag;
